import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _map from 'lodash/map';
import _noop from 'lodash/noop';
import _isEmpty from 'lodash/isEmpty';
import { arrayMove } from 'react-sortable-hoc';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import TABLE_ACTION_TYPES from '../../../../molecules/tableInputField/constants/TableInputField.actionTypes';

// Components
import InputTableRow from '../inputTableRow';
import SortableInputTableRows from './SortableInputTableRows';
var InputTableContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(InputTableContent, _PureComponent);
  var _super = _createSuper(InputTableContent);
  function InputTableContent() {
    var _this;
    _classCallCheck(this, InputTableContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "renderDataRow", function (rowData, index) {
      var _this$props = _this.props,
        columns = _this$props.columns,
        getTdProps = _this$props.getTdProps,
        onAction = _this$props.onAction,
        errors = _this$props.errors,
        getRowId = _this$props.getRowId,
        rowStyle = _this$props.rowStyle,
        highlightRowOnFocus = _this$props.highlightRowOnFocus,
        rowClassName = _this$props.rowClassName;
      var rowError = errors[index];
      var rowKey = getRowId(rowData) || index;
      return /*#__PURE__*/React.createElement(InputTableRow, {
        className: rowClassName,
        key: rowKey,
        rowIndex: index,
        rowData: rowData,
        columns: columns,
        getTdProps: getTdProps,
        onAction: onAction,
        errors: rowError,
        rowStyle: rowStyle,
        highlightRowOnFocus: highlightRowOnFocus
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;
      var _this$props2 = _this.props,
        onAction = _this$props2.onAction,
        data = _this$props2.data;
      var updatedRows = arrayMove(data, oldIndex, newIndex);
      onAction({
        type: TABLE_ACTION_TYPES.TABLE_ROWS_ORDER_CHANGE,
        payload: {
          updatedRows: updatedRows
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderSortableInputRows", function () {
      var _this$props3 = _this.props,
        data = _this$props3.data,
        columns = _this$props3.columns,
        getTdProps = _this$props3.getTdProps,
        onAction = _this$props3.onAction,
        errors = _this$props3.errors,
        getRowId = _this$props3.getRowId,
        rowStyle = _this$props3.rowStyle,
        shouldCancelStart = _this$props3.shouldCancelStart;
      return /*#__PURE__*/React.createElement(SortableInputTableRows, {
        onSortEnd: _this.handleSortEnd,
        data: data,
        columns: columns,
        getTdProps: getTdProps,
        onAction: onAction,
        errors: errors,
        rowStyle: rowStyle,
        getRowId: getRowId,
        shouldCancelStart: shouldCancelStart
      });
    });
    return _this;
  }
  _createClass(InputTableContent, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        data = _this$props4.data,
        EmptyPlaceholder = _this$props4.EmptyPlaceholder,
        loading = _this$props4.loading,
        LoadingComponent = _this$props4.LoadingComponent,
        showReOrderableRows = _this$props4.showReOrderableRows,
        contentClassName = _this$props4.contentClassName,
        contentStyle = _this$props4.contentStyle;
      if (loading) {
        return /*#__PURE__*/React.createElement(LoadingComponent, {
          loading: true
        });
      }
      if (_isEmpty(data)) {
        return /*#__PURE__*/React.createElement(EmptyPlaceholder, null);
      }
      if (showReOrderableRows) {
        return this.renderSortableInputRows();
      }
      return /*#__PURE__*/React.createElement("div", {
        style: contentStyle,
        className: contentClassName
      }, _map(data, this.renderDataRow));
    }
  }]);
  return InputTableContent;
}(PureComponent);
InputTableContent.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  getTdProps: PropTypes.func,
  onAction: PropTypes.func,
  errors: PropTypes.array,
  loading: PropTypes.bool,
  EmptyPlaceholder: PropTypes.func,
  getRowId: PropTypes.func,
  rowStyle: PropTypes.object,
  showReOrderableRows: PropTypes.bool,
  contentClassName: PropTypes.string,
  highlightRowOnFocus: PropTypes.bool,
  contentStyle: PropTypes.object,
  shouldCancelStart: PropTypes.func,
  rowClassName: PropTypes.string
};
InputTableContent.defaultProps = {
  data: EMPTY_ARRAY,
  columns: EMPTY_ARRAY,
  errors: EMPTY_ARRAY,
  getTdProps: _noop,
  onAction: _noop,
  loading: false,
  EmptyPlaceholder: _noop,
  getRowId: _noop,
  rowStyle: EMPTY_OBJECT,
  showReOrderableRows: false,
  contentClassName: '',
  highlightRowOnFocus: false,
  contentStyle: EMPTY_OBJECT,
  shouldCancelStart: undefined,
  rowClassName: undefined
};
export default InputTableContent;